export default {
    namespaced: true,
    state: () => ({
        ai: {
            review: {},
            suggestions: {},
            translation: {}
        },
        pageChecker: {}
    })
}
